import { logUserFeedbackResponseMock } from "./consts";
import { FeedbackRequestBody, FeedbackResponse } from "./types";

const submitFeedback = async (
  requestBody: FeedbackRequestBody,
  functionKey: string
): Promise<FeedbackResponse> => {
  if (process.env.REACT_APP_USE_MOCKED_API === "true") {
    await new Promise((resolve) => setTimeout(resolve, 500));
    return {
      ok: true,
      text: async () => logUserFeedbackResponseMock,
    };
  }
  const apiRequest = process.env.REACT_APP_FEEDBACK_URL + functionKey;
  const response = await fetch(apiRequest, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });
  return {
    ok: response.ok,
    text: () => response.text(),
  };
};

export const logUserFeedback = async (
  messageId: number | undefined,
  feedback: string,
  functionKey: string
) => {
  if (!messageId) return;

  const requestBody: FeedbackRequestBody = {
    response_id: messageId,
    user_feedback: feedback,
  };

  try {
    const response = await submitFeedback(requestBody, functionKey);
    if (response.ok) {
      const responseText = await response.text();
      console.log(
        `Id: ${messageId}, Feedback: "${feedback}", Response: ${responseText}`
      );
    } else {
      const responseText = await response.text();
      console.log("Id", messageId, "Error", responseText);
    }
  } catch (error: any) {
    console.log("Id", messageId, "Error", error.message);
  }
};
